module.exports = __webpack_public_path__ + "static/finance-service-mf-1af5a9c7bd9343d47f7ec93bd7b8a2ae.jpg";